module.exports = __webpack_public_path__ + "img/Jaye Harrill.d9b6f113.jpg";